"use strict";
/*
 * Created on 19. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var utils_1 = require("../../core/utils");

var ExportedRelease_1 = require("../../release/model/ExportedRelease");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var ExportedReleaseConverter_1 = require("./ExportedReleaseConverter");
/**
 * Default implementation of {@link ExportedReleaseConverter}.
 *
 * @author Radek Beran
 */


var ExportedReleaseConverterImpl =
/*#__PURE__*/
function (_ExportedReleaseConve) {
  _inherits(ExportedReleaseConverterImpl, _ExportedReleaseConve);

  function ExportedReleaseConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, ExportedReleaseConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExportedReleaseConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ExportedReleaseConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ExportedRelease_1.ExportedRelease(ExportedRelease_1.ExportedRelease.schema.id.valueOf(conversions.documentToClassId(source)), ExportedRelease_1.ExportedRelease.schema.entityId.valueOf(conversions.toClassReferenceId(source.entityId)), ExportedRelease_1.ExportedRelease.schema.exportType.valueOfField(source), ExportedRelease_1.ExportedRelease.schema.state.valueOfField(source), ExportedRelease_1.ExportedRelease.schema.created.valueOfField(source), this.userInfoConverter.toObject(source.createdBy, conversions), ExportedRelease_1.ExportedRelease.schema.lastModified.valueOfField(source), ExportedRelease_1.ExportedRelease.schema.nextAttempt.valueOfField(source), ExportedRelease_1.ExportedRelease.schema.attemptCount.valueOfField(source), utils_1.Utils.isValueMissing(source.idbWriteAttemptCount) ? 0 : ExportedRelease_1.ExportedRelease.schema.idbWriteAttemptCount.valueOfField(source), ExportedRelease_1.ExportedRelease.schema.requestId.valueOfField(source), ExportedRelease_1.ExportedRelease.schema.error.valueOfField(source), ExportedRelease_1.ExportedRelease.schema.filePath.valueOfField(source), ExportedRelease_1.ExportedRelease.schema.processId.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        entityId: conversions.toDocumentReferenceId(source.entityId)
      });
      Object.assign(result, {
        exportType: source.exportType
      });
      Object.assign(result, {
        state: source.state
      });
      Object.assign(result, {
        created: conversions.fromDate(source.created)
      });
      Object.assign(result, {
        createdBy: this.userInfoConverter.toDocument(source.createdBy, conversions)
      });
      Object.assign(result, {
        lastModified: conversions.fromDate(source.lastModified)
      });
      Object.assign(result, {
        nextAttempt: conversions.fromDate(source.nextAttempt)
      });
      Object.assign(result, {
        attemptCount: source.attemptCount
      });
      Object.assign(result, {
        idbWriteAttemptCount: source.idbWriteAttemptCount
      });
      Object.assign(result, {
        requestId: source.requestId
      });
      Object.assign(result, {
        error: source.error
      });
      Object.assign(result, {
        filePath: source.filePath
      });
      Object.assign(result, {
        processId: source.processId
      });
      return result;
    }
  }]);

  return ExportedReleaseConverterImpl;
}(ExportedReleaseConverter_1.ExportedReleaseConverter);

ExportedReleaseConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], ExportedReleaseConverterImpl);
exports.ExportedReleaseConverterImpl = ExportedReleaseConverterImpl;